import { Box, Grid } from "@mui/material";
import { ClaimBasedComponent } from "components/ClaimBasedComponent";
import NavCard from "components/NavCard";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import { ResponseOfString } from "services/KnowfullyAdminClient";
import { ClaimResource } from "types/claimTypes";
import { Environments } from "types/common-types";
import { isEnvironment } from "pages/OperationsPage/isEnvironment";

const OperationsPage = () => {
  const { formatMessage: t } = useIntl();
  const {
    importsUrl,
    klgRequestUrl,
    testDataGenerationUrl,
    processesUrl,
    healthCheckUrl,
    emailsUrl,
    e2eRegressionTestsUrl,
    webhooksUrl,
    dataToolsUrl,
    scriptRunnerUrl,
    developerDashboardUrl,
    configurationService,
  } = useGlobalContext();

  const environmentResponse = useQuery<ResponseOfString>("configurationService.getEnvironment", () =>
    configurationService.getEnvironment()
  );
  const isQa = environmentResponse.isSuccess && isEnvironment(environmentResponse.data?.data, Environments.Qa);

  return (
    <Box my={4}>
      <Grid container spacing={4}>
        <ClaimBasedComponent requestedClaims={[ClaimResource.Imports]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "importsLabel" })} url={importsUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Requests]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "menubarRequests" })} url={klgRequestUrl()} />
          </Grid>
        </ClaimBasedComponent>

        {environmentResponse.isSuccess &&
          environmentResponse.data?.data?.toLowerCase() !== Environments.Prod && (
            <ClaimBasedComponent requestedClaims={[ClaimResource.TestDataGeneration]}>
              <Grid item xs={12} sm={4}>
                <NavCard
                  title={t({ id: "testDataGenerationLabel" })}
                  url={testDataGenerationUrl()}
                />
              </Grid>
            </ClaimBasedComponent>
          )}

        <ClaimBasedComponent requestedClaims={[ClaimResource.Processes]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "processesLabel" })} url={processesUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <Grid item xs={12} sm={4}>
          <NavCard title={t({ id: "healthCheckLabel" })} url={healthCheckUrl()} />
        </Grid>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Emails]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "emails" })} url={emailsUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.Webhooks]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "webhooksLabel" })} url={webhooksUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.DataTools]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "dataTools" })} url={dataToolsUrl()} />
          </Grid>
        </ClaimBasedComponent>

        <ClaimBasedComponent requestedClaims={[ClaimResource.DataTools]}>
          <Grid item xs={12} sm={4}>
            <NavCard title={t({ id: "scriptRunner" })} url={scriptRunnerUrl()} />
          </Grid>
        </ClaimBasedComponent>

        {isQa && (
          <ClaimBasedComponent requestedClaims={[ClaimResource.DeveloperDashboard]}>
            <Grid item xs={12} sm={4}>
              <NavCard title={t({ id: "developerDashboardLabel" })} url={developerDashboardUrl()} />
            </Grid>
          </ClaimBasedComponent>
        )}

        {isQa && (
          <ClaimBasedComponent requestedClaims={[ClaimResource.E2eRegressionTests]}>
            <Grid item xs={12} sm={4}>
              <NavCard
                title={t({ id: "e2eRegressionTestsLabel" })}
                url={e2eRegressionTestsUrl()}
              />
            </Grid>
          </ClaimBasedComponent>
        )}
      </Grid>
    </Box>
  );
};

export default OperationsPage;
